import { Injectable } from '@angular/core';

@Injectable()
export class CalculatorProvider {

  constructor() {

  }

  getOverpaymentCalulator(amount, rate, term, overpayment) {
    let OP = parseFloat(overpayment);
    let P = parseFloat(amount);
    let original_p = parseFloat(amount);
    let r = (parseFloat(rate) / 100) / 12;
    let n = (term);
    let x = Math.pow(1 + r, n);

    // let M = (P * ((r * x) / (x - 1))).toFixed(2);
    let EMI = (P * ((r * x) / (x - 1)));


    let noMonths1 = (Math.log(EMI / original_p) - Math.log((EMI / original_p) - parseFloat(rate) / 1200)) / Math.log(1 + parseFloat(rate) / 1200);

    let changed_EMI = OP > 0 ? EMI + OP : EMI;

    let noMonths2 = (Math.log(changed_EMI / original_p) - Math.log((changed_EMI / original_p) - parseFloat(rate) / 1200)) / Math.log(1 + parseFloat(rate) / 1200)

    let PayAmount1 = EMI * noMonths1;
    let PayAmount2 = changed_EMI * noMonths2;

    let savedMonths = Math.round(Math.abs(noMonths2 - noMonths1));
    let savedAmount = Math.round(Math.abs(PayAmount2 - PayAmount1));
    let output = "The term of your mortgage will reduce by " + savedMonths + " months and you will save approx. £" + savedAmount + " in interest";
    return output;
  }

  calculateMortgagebyTerm(amount, current_interest_rate, years, months) {
    years == "" ? years = 0 : years;
    months == "" ? months = 0 : months;
    let P = parseFloat(amount);
    let r = (parseFloat(current_interest_rate) / 100) / 12;
    let n = parseInt(years) * 12 + parseInt(months);
    let x = Math.pow(1 + r, n);

    let EMI = (P * ((r * x) / (x - 1)));
    let output = EMI.toFixed(2).toString();
    return output;
  }

  calculateMortgageByEMI(amount, emi, current_interest_rate) {
    let original_p = parseFloat(amount);

    let EMI = parseFloat(emi);

    let noMonths = Math.round((Math.log(EMI / original_p) - Math.log((EMI / original_p) - parseFloat(current_interest_rate) / 1200)) / Math.log(1 + parseFloat(current_interest_rate) / 1200));

    let obj = {
      years: Math.round((noMonths / 12)).toString(),
      months: (noMonths % 12).toString()
    }
    return obj;
  }

  calculateRateChangeInterest(amount, current_interest_rate, years, months, ratechange) {

    let P = parseFloat(amount);
    let r = (parseFloat(current_interest_rate) / 100) / 12;
    let r1 = ((parseFloat(current_interest_rate) + ratechange) / 100) / 12;
    let n = parseInt(years) * 12 + parseInt(months);
    let x = Math.pow(1 + r, n);
    let x1 = Math.pow(1 + r1, n);

    let EMI = (P * ((r * x) / (x - 1)));

    let EMI2 = (P * ((r1 * x1) / (x1 - 1)));

    let additionalEMI = EMI2 - EMI;
    let additionalInterest = ((EMI2 - EMI) * n).toFixed(2);

    document.getElementById("divCalInfo").style.display = "block";
    let output = "£ " + additionalEMI.toFixed(2) + " per month with additional interest over the term of £ " + additionalInterest;

    return output;

  }

}



// WEBPACK FOOTER //
// ./src/providers/calculator/calculator.ts